import React from 'react';
import { useIntersectionObserver } from './hooks';
export const scrollToCheckout = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  const checkoutSection = document.getElementById('checkout');
  if (checkoutSection) {
    checkoutSection.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  children: React.ReactNode;
  className?: string;
}
export const Button = ({
  variant = 'primary',
  size = 'lg',
  children,
  className = '',
  ...props
}: ButtonProps) => {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 transform hover:scale-[1.03] text-center';
  const variants = {
    primary: 'bg-herbal hover:bg-herbalDark text-white shadow-premium hover:shadow-glow-herbal',
    secondary: 'bg-gold hover:bg-yellow-500 text-petroleum shadow-glow-gold'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl w-full max-w-md'
  };
  return <a href="#checkout" onClick={scrollToCheckout} className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-483">
      {children}
    </a>;
};
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  bg?: 'cream' | 'beige' | 'dark' | 'none';
  id?: string;
}
export const Section = ({
  children,
  className = '',
  bg = 'none',
  id
}: SectionProps) => {
  const [ref, isVisible] = useIntersectionObserver();
  const bgColors = {
    cream: 'bg-cream bg-texture-paper',
    beige: 'bg-beige bg-texture-paper',
    dark: 'bg-petroleum text-cream bg-gradient-dark',
    none: ''
  };
  return <section id={id} className={`py-16 md:py-24 relative ${bgColors[bg]} ${className}`} data-id="element-484">
      <div ref={ref} className={`max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 animate-on-scroll ${isVisible ? 'is-visible' : ''}`} data-id="element-485">
        {children}
      </div>
    </section>;
};
export const OrganicDivider = ({
  type = 'wave',
  color = 'fill-cream'
}) => {
  if (type === 'wave') {
    return <div className="w-full overflow-hidden leading-none -mt-1 relative z-10" data-id="element-486">
        <svg className="relative block w-full h-[40px] md:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-487">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className={color} data-id="element-488"></path>
        </svg>
      </div>;
  }
  return <div className="w-full overflow-hidden leading-none -mt-1 relative z-10 rotate-180" data-id="element-489">
      <svg className="relative block w-full h-[40px] md:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-490">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className={color} data-id="element-491"></path>
      </svg>
    </div>;
};